import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appUnless]'
})
export class UnlessDirective {
  @Input() set appUnless(condition: boolean) {
    if (!condition) {
      this.vcRef.createEmbeddedView(this.templateRef);
    } else {
      this.vcRef.clear();
    }
  }

  // templateRef: kondisyon doğru ise ekrana yazdırılmak istenen item yani içerisine bind ettiğimiz element
  // viewContaimer: ekrana yazdırmak istediğimiz element ya da templete yazdıran ya da silen

  constructor(private templateRef: TemplateRef<any>, private vcRef: ViewContainerRef) {
  }

}
